import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// Components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';
import TwoFactorSetup from '../Admin/Users/TwoFactorSetup';
import LoadingSpinner from '../../elements/LoadingSpinner.js';
import newlogo from '../../assets/img/new-logo.png';

class Setup2FAPage extends Component {

    constructor(props) {
        super(props);
        this.state = { loading: true, redirectToLogin: false };
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const urlToken = params.get('token');

        if (urlToken) {
            window.sessionStorage.setItem('x-setup-2fa-token', urlToken);
            window.history.replaceState(null, '', window.location.pathname);
            this.setState({ loading: false });
        } else if (!window.sessionStorage.getItem('x-setup-2fa-token')) {
            this.setState({ redirectToLogin: true, loading: false });
        } else {
            this.setState({ loading: false });
        }
    }

    render() {
        const { t } = this.props;
        const { loading, redirectToLogin } = this.state;

        if (loading) return <LoadingSpinner />;
        if (redirectToLogin) return <Navigate to="/login" replace />;

        return (
            <div>
                <div className="auth-page-wrapper">
                    <ToastContainer />
                    <div className="auth-page-card">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h2 className="fs22 loginTitle">{t('Two-Factor Authentication').toUpperCase()}</h2>
                            <img src={newlogo} alt="Logo" style={{ height: 42, cursor: 'pointer' }} onClick={() => this.props.router.navigate('/')} />
                        </div>
                        <TwoFactorSetup source={'login'} />
                    </div>
                </div>
            </div>
        );
    }
}

export default inject('authStore')(applicationRouter(withLocalization(observer(Setup2FAPage))));
